import { i18n } from "@/shared/i18n/i18n";
import { Reason } from "@/app/fbs-hub-app/shared/@types";

const reasonTranslations: Record<Reason, string> = {
  [Reason.Billing]: i18n.t("fbsHub.meterReport.reason.billing"),
  [Reason.Other]: i18n.t("fbsHub.meterReport.reason.other"),
  [Reason.PriceChange]: i18n.t("fbsHub.meterReport.reason.priceChange"),
  [Reason.MoveOut]: i18n.t("fbsHub.meterReport.reason.moveOut"),
};

const UNIVERSAL_REASONS = [Reason.PriceChange, Reason.MoveOut];
const BILLING_SEASON_REASONS = [Reason.Billing, ...UNIVERSAL_REASONS];
const NON_BILLING_SEASON_REASONS = [Reason.Other, ...UNIVERSAL_REASONS]; // translates to "Ablesung" in SAP

export const getReasonOptions = (isBillingSeason: boolean) => {
  const reasonOptions = Object.entries(reasonTranslations)
    .filter(([key]) =>
      isBillingSeason
        ? BILLING_SEASON_REASONS.includes(key as Reason)
        : NON_BILLING_SEASON_REASONS.includes(key as Reason),
    )
    .map(([key, value]) => ({ key, value }));

  return reasonOptions;
};
